export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const GET_ROYALTY_CONTRACT_SUCCESS = 'GET_ROYALTY_CONTRACT_SUCCESS';
